export default __webpack_public_path__ + "static/media/profit-and-loss-w.99585811.png";